import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const StyledBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 30px;
`;

export { StyledBottomContainer, StyledContainer };
